import {
    setIsColorGradingFiltersError,
    setIsColorGradingFiltersLoading,
    storeColorGradingFilters,
} from './color-grading-slice';

import { ApiService } from 'js/src/client';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch } from 'js/src/libs/RootState';

/**
 * Fetches and stores color filters for color grading.
 */
export const loadColorGradingFilterList = () => {
    return async (dispatch: AppDispatch) => {
        dispatch(setIsColorGradingFiltersError(false));
        dispatch(setIsColorGradingFiltersLoading(true));
        try {
            const response = await ApiService.colorFilterList();
            dispatch(storeColorGradingFilters({ colorGradingFilters: response.data }));
            dispatch(setIsColorGradingFiltersLoading(false));
        } catch (error) {
            ErrorReporter.capture(error);
            dispatch(setIsColorGradingFiltersLoading(false));
            dispatch(setIsColorGradingFiltersError(true));
        }
    };
};
